import React from "react";
import { Input } from "@/components/ui/input";

interface HotelCountRangeFilterProps {
  label: string;
  minPlaceholder: string;
  maxPlaceholder: string;
  minValue: string;
  maxValue: string;
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
  errorMessage?: string;
}

const updateNonNegativeInteger = (
  value: string,
  onChange: (value: string) => void,
): void => {
  if (/^\d*$/.test(value)) {
    onChange(value);
  }
};

export const HotelCountRangeFilter: React.FC<HotelCountRangeFilterProps> = ({
  label,
  minPlaceholder,
  maxPlaceholder,
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  errorMessage,
}) => {
  const errorId = `${label.toLowerCase().replace(/\s+/g, "-")}-range-error`;

  return (
    <fieldset className="flex min-w-0 flex-col gap-1.5">
      <legend className="sr-only">{label}</legend>
      <div className="flex items-center gap-2">
        <Input
          type="number"
          min={0}
          inputMode="numeric"
          value={minValue}
          onChange={(event) =>
            updateNonNegativeInteger(event.target.value, onMinChange)
          }
          placeholder={minPlaceholder}
          aria-label={minPlaceholder}
          aria-invalid={Boolean(errorMessage)}
          aria-describedby={errorMessage ? errorId : undefined}
          className="h-8 min-w-0"
        />
        <span aria-hidden="true" className="text-muted-foreground">
          –
        </span>
        <Input
          type="number"
          min={0}
          inputMode="numeric"
          value={maxValue}
          onChange={(event) =>
            updateNonNegativeInteger(event.target.value, onMaxChange)
          }
          placeholder={maxPlaceholder}
          aria-label={maxPlaceholder}
          aria-invalid={Boolean(errorMessage)}
          aria-describedby={errorMessage ? errorId : undefined}
          className="h-8 min-w-0"
        />
      </div>
      {errorMessage ? (
        <p
          id={errorId}
          role="alert"
          className="text-custom-destructive-dark text-xs"
        >
          {errorMessage}
        </p>
      ) : null}
    </fieldset>
  );
};
